'use client';

import { useUserContext } from '@/providers/user-context-provider';
import { EntitlementType } from '@spikemark/auth';
import { Pill } from '@spikemark/ui/components/design-system/pill/pill';
const badgeLabelsMap = new Map([[EntitlementType.ProAnalytics, 'Coach Portal Pro'], [EntitlementType.QualifyingLiveScoring, 'Coach Portal Standard'], [EntitlementType.CoachPortalAccess, 'Coach Portal Entry']]);
export const UserPlanBadge = () => {
  const {
    activeTeamPlan
  } = useUserContext();
  const label = activeTeamPlan ? badgeLabelsMap.get(activeTeamPlan)! : 'Coach Portal Entry';
  return <Pill text={label} color="softGold" className="font-medium text-3xs mr-4 cursor-pointer" data-sentry-element="Pill" data-sentry-component="UserPlanBadge" data-sentry-source-file="user-plan-badge.tsx" />;
};